import { css } from 'styled-components';

export const Panel = css`
  display: inline-block;
  max-width: 340px;
  width: 100%;
  padding: 35px 25px;
`;

export const Logobox = css`
  display: block;
  width: 100%;
  margin-bottom: 30px;
`;

export const Logo = css`
  display: block;
  max-width: 100%;
  height: auto;
  margin: auto;
`;

export const Textbox = css`
  display: block;
  width: 100%;
  margin-top: 15px;
  margin-bottom: 25px;
  text-align: center;
`;

export const Text = css`
  font-size: 22px;
  font-weight: 400;
  line-height: 1.2;
  color: ${(props) => props.theme.color};
  cursor: default;
`;

export const Form = css`
  display: block;
  width: 100%;
`;

export const Linkbox = css`
  display: block;
  text-align: center;

  a {
    display: inline-block;
    margin: 3px 5px;
    transition: 0.2s color;
    color: ${(props) => props.theme.color};
    font-size: 14px;
    font-weight: 700;
    text-decoration: underline;
    cursor: pointer;

    &:hover {
      color: ${(props) => props.theme.colorOnHover};
    }
  }
`;
